const memoryCache = new Map<string, string>();
const inflight = new Map<string, Promise<string>>();

const STORAGE_PREFIX = "dashly.dataserviceLogo.v1.";
/** Skip sessionStorage for oversized data-URLs so one logo cannot blow the tab quota. */
const SESSION_MAX_CHARS = 400_000;

export const peekDataserviceLogoSrc = (dataserviceUuid: string): string | undefined => {
	const memory = memoryCache.get(dataserviceUuid);
	if (memory !== undefined) {
		return memory;
	}
	try {
		const stored = sessionStorage.getItem(STORAGE_PREFIX + dataserviceUuid);
		if (stored != null) {
			memoryCache.set(dataserviceUuid, stored);
			return stored;
		}
	} catch {
		// sessionStorage may be unavailable (private mode / quota)
	}
	return undefined;
};

export const rememberDataserviceLogoSrc = (dataserviceUuid: string, src: string): void => {
	memoryCache.set(dataserviceUuid, src);
	try {
		if (src.length <= SESSION_MAX_CHARS) {
			sessionStorage.setItem(STORAGE_PREFIX + dataserviceUuid, src);
		}
	} catch {
		// quota / private mode — memory cache still covers this tab session
	}
};

export const invalidateDataserviceLogoCache = (dataserviceUuid: string): void => {
	memoryCache.delete(dataserviceUuid);
	inflight.delete(dataserviceUuid);
	try {
		sessionStorage.removeItem(STORAGE_PREFIX + dataserviceUuid);
	} catch {
		// ignore
	}
};

export const getDataserviceLogoInflight = (dataserviceUuid: string): Promise<string> | undefined =>
	inflight.get(dataserviceUuid);

export const setDataserviceLogoInflight = (dataserviceUuid: string, request: Promise<string>): void => {
	inflight.set(dataserviceUuid, request);
};

export const clearDataserviceLogoInflight = (dataserviceUuid: string): void => {
	inflight.delete(dataserviceUuid);
};
